import { Dialog, Transition } from "@headlessui/react";
import * as htmlToImage from "html-to-image";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import paymentSuccess from "../../assets/images/icon_invoice/payment-success.svg";
import { isDarkColor } from "../../config/DarkColorChecker";
import { formatCurrency } from "../../config/global";
import { downloadBase64 } from "../../config/iosBridge";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import {
  getInvoiceDetail,
  invoicePayment,
} from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import TabsMobile from "../__template/TabsMobileComponent";
import { toast } from "react-toastify";

const ComponentInvoiceDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any>({});
  const [dataHistory, setDataHistory] = useState<any>([]);
  const [dataDetail, setDataDetail] = useState<any>([]);

  let [isOpen, setIsOpen] = useState(false);
  const ref2 = useRef<HTMLDivElement>(null);
  var invoicea = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var placeholder = `${t("INVOICE.placeholder")}`;
  const id = useParams();
  const [amount, setAmount] = useState<any>(0);
  const [openPaymentSuccessInvoice, setOpenPaymentSuccessInvoice] =
    useState(false);
  const [detailPaymentSuccess, setDetailPaymentSuccess] = useState<any>([]);
  const [url, setUrl] = useState<string>("none");
  const [minimumPayment, setMinimumPayment] = useState<number>(0);
  const [underMinimumPayment, setUnderMinimumPayment] =
    useState<boolean>(false);
  let [isOpen2, setIsOpen2] = useState(false);
  const [isExpandedDescription, setIsExpandedDescription] = useState(false);
  const DESCRIPTION_LIMIT = 100;
  const isLongDescription = (data?.description?.length || 0) > DESCRIPTION_LIMIT;

  const shareButton = useRef<HTMLButtonElement>(null);

  const closeCreate2 = () => {
    setIsOpen2(false);
  };
  const payment = () => {
    if (data.creditDetailPayment)
      return navigate(`/invoice-credit-payment`, { state: { data: data } });
    if (
      data.partialMethod &&
      minimumPayment > (amount || 0) &&
      data.amount - data.paidAmount > minimumPayment
    )
      return alert(`Pembayaran minimum ${formatCurrency(minimumPayment)}`);
    setIsOpen2(true);
  };

  function onDismissPaymentSuccessInvoice() {
    window.scrollTo(0, 0);
    setOpenPaymentSuccessInvoice(false);
    navigate("/invoice");
  }

  const downloadForm = async () => {
    dispatch(setLoading(true));
    // setShowDescription(false);
    // Be sure to check for the "none" state, so we don't trigger an infinite loop.
    if (url === "none") {
      if (ref.current === null) {
        return;
      }

      htmlToImage
        .toPng(ref.current, { cacheBust: true })
        .then((dataUrl) => {
          if (localStorage.getItem("device")?.includes("ios")) {
            downloadBase64(dataUrl);
            dispatch(setLoading(false));
            // setShowDescription(true);
          } else {
            var link = document.createElement("a");
            link.href = dataUrl;
            console.log(dataUrl, "sukses");
            var iframe =
              "<iframe width='100%' height='100%' src='" +
              dataUrl +
              "'></iframe>";

            const linkSource = dataUrl;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download =
              detailPaymentSuccess.inquiryResponseDto?.title +
              " - " +
              detailPaymentSuccess.inquiryResponseDto?.customerName;
            downloadLink.click();

            dispatch(setLoading(false));
            // setShowDescription(true);
            // link.click();
          }
        })
        .catch((err) => {
          console.log(err);

          dispatch(setLoading(false));
          // setShowDescription(true);
        });
    }
  };

  const getInvoice = async () => {
    dispatch(setLoading(true));
    getInvoiceDetail(id)
      .then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data);
        setDataHistory(res.data.history);
        setDataDetail(res.data.detail);
        setIsExpandedDescription(false);
        let minPayment = res.data.minimumPayment;
        if (res.data.minimumPaymentType === "PERCENT")
          minPayment = (minPayment / 100) * res.data.amount;
        if (minPayment == 0) minPayment = 10000;
        setMinimumPayment(minPayment);
        let underMin = res.data.amount - res.data.paidAmount < minPayment;
        if (underMin) setAmount(res.data.amount - res.data.paidAmount);
        setUnderMinimumPayment(underMin);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const handleSubmit = () => {
    let newData = {
      invoiceId: data.invoiceId,
      amount:
        !data?.creditDetailPayment && data?.partialMethod
          ? parseInt(amount)
          : data?.amount,
      channel: "MOBILE",
      cash: false,
      tag: "",
    };

    dispatch(setLoading(true));
    invoicePayment(newData)
      .then((res: any) => {
        setDetailPaymentSuccess(res.data);
        setOpenPaymentSuccessInvoice(true);
        closeCreate2();
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  useEffect(() => {
    getInvoice();
  }, []);

  return (
    <div className="min-h-screen h-full bg-psp-primary">
      <div className="bg-primary px-3 pt-4 pb-3  sticky top-0 h-44">
        <TabsMobile
          name={`${t("INVOICE.title")}`}
          backUrl={"home"}
        ></TabsMobile>
        {/* ====================== SUCCESS BOTTOMSHEET ===================== */}
        <BottomSheet
          open={openPaymentSuccessInvoice}
          onDismiss={onDismissPaymentSuccessInvoice}
          defaultSnap={({ snapPoints, lastSnap }) =>
            lastSnap ?? Math.min(...snapPoints)
          }
          snapPoints={({ maxHeight }) => [
            maxHeight - maxHeight / 5,
            maxHeight * 0.8,
          ]}
          header={""}
          footer={
            <div className="flex flex-col gap-2 z-[1000]">
              {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
              {t("INVOICE.share")}
            </button> */}
              <button
                onClick={downloadForm}
                style={{ backgroundColor: customApp?.app_accent_color }}
                className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                  isDarkColor(customApp.app_accent_color)
                    ? "text-white"
                    : "text-black"
                }`}
              >
                {t("INVOICE.download")}
              </button>
              <button
                onClick={() => onDismissPaymentSuccessInvoice()}
                style={{
                  backgroundColor: customApp?.app_secondary_accent_color,
                }}
                className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                  isDarkColor(customApp.app_secondary_accent_color)
                    ? "text-white"
                    : "text-black"
                }`}
              >
                {t("OTHER.close")}
              </button>
            </div>
          }
        >
          <div className="px-4 py-2 bg-white" ref={ref}>
            <div className="flex flex-col items-center gap-1 mb-6">
              <img className="w-24 h-24 mb-1" src={paymentSuccess} alt="" />
              <h1 className="m-0 font-montserrat text-2xl font-medium">
                {t("INVOICE.success")}
              </h1>
              <span className="font-montserrat text-sm text-psp-nav font-light">
                {t("INVOICE.date")} :{" "}
                {moment(detailPaymentSuccess.dateTime).format("LLL")}
              </span>
            </div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.paymentData")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.studentName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="font-poppins grow text-right">
                  {detailPaymentSuccess.inquiryResponseDto?.customerName}
                </div>
              </div>
            </div>
            <hr />
            <div>
              <h1 className="font-poppins font-medium text-sm text-black my-2">
                {t("INVOICE.detailInvoice")}
              </h1>
              <div className="grid grid-cols-2 gap-1">
                <div className="flex flex-row">
                  <h1 className="font-poppins font-normal text-sm text-psp-nav">
                    {t("INVOICE.invoiceName")}
                  </h1>
                </div>
                <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                  <div className="grow text-right">
                    {" "}
                    {detailPaymentSuccess.inquiryResponseDto?.title}
                  </div>
                </div>
              </div>
              <div className="font-poppins grid grid-cols-2 gap-1">
                <div className="flex flex-row">
                  <h1 className=" font-normal text-sm text-psp-nav">
                    {t("INVOICE.payDate")}
                  </h1>
                </div>
                <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                  <div className="grow text-right">
                    {moment(detailPaymentSuccess.dateTime).format("LL")}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-1">
                <div className="flex flex-row">
                  <h1 className="font-poppins font-normal text-sm text-psp-nav">
                    {t("INVOICE.invoiceType")}
                  </h1>
                </div>
                <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                  <div className="grow text-right">
                    {detailPaymentSuccess.inquiryResponseDto?.partialMethod ==
                    false
                      ? t("INVOICE.cash")
                      : t("INVOICE.credit")}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-1" hidden>
                <div className="flex flex-row">
                  <h1 className="font-poppins font-normal text-sm text-psp-nav">
                    Status
                  </h1>
                </div>
                <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                  <div className="grow text-right"></div>
                </div>
              </div>
              <div
                hidden={!detailPaymentSuccess?.inquiryResponseDto?.showDetail}
              >
                {detailPaymentSuccess?.inquiryResponseDto?.detail?.map(
                  (res: any) => (
                    <div className="grid grid-cols-2 gap-1">
                      <div className="flex flex-row">
                        <h1 className="font-poppins font-normal text-sm text-psp-nav">
                          {res.title}
                        </h1>
                      </div>
                      <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                        <div className="grow text-right">
                          {formatCurrency(res.amount)}
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>

            <hr />
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.total")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {formatCurrency(
                    detailPaymentSuccess?.inquiryResponseDto?.amount,
                  )}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.totalpay")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {formatCurrency(detailPaymentSuccess?.amount)}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.minus")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {formatCurrency(
                    detailPaymentSuccess?.inquiryResponseDto?.amount -
                      (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                        detailPaymentSuccess?.amount),
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center gap-2 mb-3"></div>
          </div>
        </BottomSheet>
        {/* ================================================================ */}
        <Transition appear show={isOpen2} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeCreate2}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("LOGIN.confirm")}
                    </Dialog.Title>
                    <div>
                      <p className="text-sm text-gray-500 mt-2">
                        Apakah anda yakin ingin membayar tagihan ini?{" "}
                        {!data?.creditDetailPayment && data?.partialMethod
                          ? `(${formatCurrency(amount)})`
                          : `(${formatCurrency(data?.amount)})`}
                      </p>
                    </div>
                    <div className="justify-center mt-4 flex gap-2">
                      <button
                        type="button"
                        style={{
                          backgroundColor:
                            customApp?.app_secondary_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_secondary_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => closeCreate2()}
                      >
                        {t("OTHER.no")}
                      </button>
                      <button
                        type="button"
                        style={{
                          backgroundColor: customApp?.app_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => handleSubmit()}
                      >
                        {t("OTHER.yes")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <div className="p-4 top-to-bottom overflow-y-auto max-h-[calc(108vh-200px)]">
          <div className="p-3 bg-white mt-4 rounded-lg">
            <div className="text-center">
              <span className="font-montserrat m-0 text-xs font-normal text-psp-nav">
                Sisa Tagihan
              </span>
            </div>
            <div className="text-center mt-4 flex items-center justify-center">
              <span className="text-red text-2xl ml-1">
                {formatCurrency(data.amount - data.paidAmount)}
              </span>
            </div>
            <hr />
            <div className="grid grid-cols-2  mt-3 ml-2">
              <div className="flex flex-col ml-6">
                <h1 className="m-0 text-xs font-normal text-psp-nav text-center">
                  Terbayar
                </h1>
              </div>
              <h1 className="m-0 text-xs font-normal text-psp-nav text-center">
                Nominal Tagihan
              </h1>
            </div>
            <div className="grid grid-cols-2  mt-3 ml-2">
              <div className="flex flex-col">
                <h6 className="m-0  font-normal text-psp-nav text-center">
                  {formatCurrency(data.paidAmount)}
                </h6>
              </div>
              <h6 className="m-0  font-normal text-psp-nav text-center">
                {formatCurrency(data.amount)}
              </h6>
            </div>
          </div>
          {!data?.creditDetailPayment && data?.partialMethod && (
            <div className="rounded-2xl bg-white p-3 mt-4">
              <div className="mb-4">
                <label
                  htmlFor="amount"
                  className="block text-xs font-medium text-psp-nav mb-1"
                >
                  Masukkan Nominal
                </label>
                {minimumPayment > (amount || 0) && underMinimumPayment ? (
                  <CurrencyInput
                    className="px-2 py-2 mt-1 rounded-xl h-auto border-1 border-psp-border-gray border-solid active:border-0 w-full"
                    decimalsLimit={2}
                    disabled={true}
                    value={amount}
                    prefix={"Rp "}
                    onValueChange={(value, name) => {
                      setAmount(value || "");
                    }}
                  />
                ) : (
                  <CurrencyInput
                    className="px-2 py-2 mt-1 rounded-xl h-auto border-1 border-psp-border-gray border-solid active:border-0 w-full"
                    decimalsLimit={2}
                    prefix={"Rp "}
                    onValueChange={(value, name) => {
                      setAmount(value || "");
                    }}
                  />
                )}
              </div>
            </div>
          )}
          <div>
            <div className="rounded-2xl bg-white p-3 mt-4">
              <table className="w-full">
                <tr>
                  <td>
                    <h6 className=" font-normal text-psp-nav">
                      Data Pembayaran
                    </h6>
                  </td>
                  {/* <td>:</td> */}
                  <td className="text-right">
                    <div className="text-xs"></div>{" "}
                  </td>
                </tr>
                <tr className="items-center">
                  <td>
                    <div className="text-xs font-normal text-psp-nav">
                      Nama Siswa
                    </div>
                  </td>

                  <td className="text-right">
                    <div>
                      <div>
                        <span className="text-xs">{data.callerName}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div className="rounded-2xl bg-white p-3 mt-4">
              <table className="w-full">
                <tr className="hidden">
                  <td>
                    <div className="text-xs">
                      {t("DIGITALCARD.balanceCard")}
                    </div>
                  </td>
                  <td>:</td>
                  <td className="text-right">
                    <div className="text-xs">
                      {/* {getCurrency(selectedCard?.cardBalance)} */}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h6 className=" font-normal text-psp-nav">
                      Detail Tagihan
                    </h6>
                  </td>
                  {/* <td>:</td> */}
                  <td className="text-right">
                    <div className="text-xs"></div>{" "}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="text-xs font-normal text-psp-nav">
                      Nama Tagihan
                    </div>
                  </td>

                  <td className="text-right">
                    <div className="text-xs">{data.title}</div>
                  </td>
                </tr>
                <tr className="items-center">
                  <td>
                    <div className="text-xs font-normal text-psp-nav">
                      Tgl Tagihan
                    </div>
                  </td>

                  <td className="text-right">
                    <div>
                      <div>
                        <span className="text-xs">{data.invoiceDate}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className="items-center">
                  <td>
                    <div className="text-xs font-normal text-psp-nav">
                      Jatuh Tempo
                    </div>
                  </td>

                  <td className="text-right">
                    <div>
                      <div>
                        <span className="text-xs">{data.dueDate}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className="items-center">
                  <td>
                    <div className="text-xs font-normal text-psp-nav">
                      Tipe Tagihan
                    </div>
                  </td>

                  <td className="text-right">
                    <div>
                      <div>
                        <span className="text-xs">{data.status}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="text-xs font-normal text-psp-nav mb-1">
                      Deskripsi
                    </div>
                    {!data.description?.trim() ? (
                      <div className="text-xs text-psp-nav italic">-</div>
                    ) : (
                      <>
                        <div
                          id="invoice-description"
                          className="text-xs text-justify break-words whitespace-pre-wrap"
                        >
                          {isLongDescription && !isExpandedDescription
                            ? data.description.substring(0, DESCRIPTION_LIMIT) +
                              "..."
                            : data.description}
                        </div>
                        {isLongDescription && (
                          <button
                            onClick={() =>
                              setIsExpandedDescription(!isExpandedDescription)
                            }
                            aria-expanded={isExpandedDescription}
                            aria-controls="invoice-description"
                            className="text-xs font-medium text-blue-600 underline mt-1"
                          >
                            {isExpandedDescription
                              ? t("INVOICE.hideDescription")
                              : t("INVOICE.showAllDescription")}
                          </button>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              </table>
            </div>
            {data.showDetail ||
            (data.creditDetailPayment && data.partialMethod) ? (
              <div className="rounded-2xl bg-white p-3 mt-4">
                <table className="w-full">
                  <tr className="hidden">
                    <td>
                      <div className="text-xs">
                        {t("DIGITALCARD.balanceCard")}
                      </div>
                    </td>
                    <td>:</td>
                    <td className="text-right">
                      <div className="text-xs">
                        {/* {getCurrency(selectedCard?.cardBalance)} */}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 className=" font-normal text-psp-nav">Rincian</h6>
                    </td>
                    {/* <td>:</td> */}
                    <td className="text-right">
                      <div className="text-xs"></div>{" "}
                    </td>
                  </tr>

                  {data.detail?.map((prop: any) => {
                    return (
                      <tr className="mb-2">
                        <td>
                          <div className="text-xs font-normal text-psp-nav">
                            {prop.title}
                          </div>
                        </td>

                        <td className="text-right">
                          <div className="text-xs">
                            {formatCurrency(prop.amount - (prop.discount || 0))}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="p-3 bg-psp-primary fixed bottom-0 left-0 w-full">
        <button
          onClick={() => {
            if (
              data.partialMethod &&
              data.creditDetailPayment &&
              data.detail?.reduce((a: any, b: any) => a + b.paidAmount, 0) !=
                data.paidAmount
            )
              toast.error("Pembayaran tagihan ini tidak dapat dilakukan.");
            else payment();
          }}
          style={{
            backgroundColor:
              data.partialMethod && !data.creditDetailPayment && !amount
                ? "gray"
                : customApp?.app_accent_color,
            width: "100%",
          }}
          disabled={data.partialMethod && !data.creditDetailPayment && !amount}
          className={`px-2 py-2.5 rounded-lg font-bold text-xs active:bg-psp-active ${
            isDarkColor(customApp.app_accent_color)
              ? "text-white"
              : "text-black"
          }`}
        >
          {t("INVOICE.pay")}
        </button>
      </div>
    </div>
  );
};

export default ComponentInvoiceDetail;
